import React from "react";
import { ADD_PIN } from "src/shared/config";
import { ApiResponse } from "src/shared/types";
import appFetch from "src/shared/fetch";

const headers = new Map();
headers.set("Content-Type", "application/json");

export const addPin = (data: string): ApiResponse =>
  appFetch.post(ADD_PIN, {
    body: data,
    headers: { "Content-Type": "application/json" },
    statusMessageConfig: {
      2: "Pin added successfully",
      400: (
        <p>
          Pinned metric with this <b>label</b> already exists. Please try a unique label name.
        </p>
      ),
      4: "Pin couldn't be added",
      5: "Pin couldn't be added",
    },
  });
